import React from 'react'
import moment from 'moment'
import { COLORES } from '../../../../../../config/colores'
import TableValueAction from '../../../../../MuiTable/components/TableValueAction'
import InfoCpa from '../../../busquedaCpa/InfoCpa'

export function getColumnasCamionesBrutoYDestare (rol) {
  return ([
    {
      name: 'fechaDeBruto',
      label: 'Fecha bruto',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (fecha) => fecha ? <>{moment(fecha).format('DD-MM HH:mm')}</> : null,
        setCellProps: () => ({
          style: {
            position: 'sticky',
            left: '0',
            background: COLORES.grey.light,
            zIndex: 10000
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            left: 0,
            background: 'white',
            zIndex: 10100
          }
        })
      }
    },
    {
      name: 'fechaDeVolcado',
      label: 'Fecha volcado',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (fecha) => fecha ? <>{moment(fecha).format('DD-MM HH:mm')}</> : null
      }
    },
    {
      name: 'cartaDePorteAutomotor',
      label: 'Carta de porte',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (numero) => {
          return (
            <>
              { numero
                ? <TableValueAction
                  value={numero}
                  title=' '
                  content={<InfoCpa cpa={numero} />} />
                : null
              }
            </>
          )
        }
      }
    },
    {
      name: 'exportador',
      label: 'Exportador',
      options: {
        filter: true,
        sort: true,
        display: false,
        filterType: 'multiselect'
      }
    },
    {
      name: 'titularDeCupo',
      label: 'Titular de cupo',
      options: {
        filter: true,
        sort: true,
        display: false,
        filterType: 'multiselect'
      }
    },
    {
      name: 'titular',
      label: 'Titular CPE',
      options: {
        filter: true,
        sort: true,
        display: false,
        filterType: 'multiselect'
      }
    },
    {
      name: 'camion',
      label: 'Camión',
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: 'cereal',
      label: 'Cereal',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox',
        filterList: []
      }
    },
    {
      name: 'cerealVariedad',
      label: 'Cereal variedad',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox',
        filterList: [],
        customBodyRender: (v) => {
          return ((v.trim() === 'UNDEF') ? ' - ' : v)
        }
      }
    },
    {
      name: 'pesoBruto',
      label: 'Peso bruto',
      options: {
        filter: false,
        sort: true,
        total: true
      }
    },
    {
      name: 'calificacionCereal',
      label: 'Calificación cereal',
      options: {
        filter: true,
        sort: true,
        filterType: 'multiselect'

      }
    },
    {
      name: 'volcadoraCamiones',
      label: 'Volcadora camiones',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox'
      }
    },
    {
      name: 'calleDeVolcadora',
      label: 'Calle de volcadora',
      options: {
        filter: true,
        sort: true,
        display: ((rol && rol[0] !== 'EXPORTADOR' && rol[1] !== 'EXPORTADOR')),
        filterType: 'checkbox'
      }
    },
    {
      name: 'autodescargable',
      label: 'Autodescargable',
      options: {
        filter: true,
        sort: true,
        display: false,
        filterList: [],
        customBodyRender: autodescargable => {
          return (autodescargable) ? 'Si' : '  '
        }
      }
    }
  ])
}

export const COLUMNS_CAMIONES_ENTRE_BRUTO_Y_DESTARE_TO_PRINT = [
  {
    name: 'camion',
    label: 'Camion',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'acoplado',
    label: 'Acoplado',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoNetoOrigen',
    label: 'Peso Neto Origen',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoTaraOrigen',
    label: 'Peso Tara Origen',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoBrutoOrigen',
    label: 'Peso Bruto Origen',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'ctg',
    label: 'Ctg',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'fechaDeIngreso',
    label: 'Fecha De Ingreso',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'fechaCupo',
    label: 'Fecha Cupo',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'fechaAsignacionTurnoDeSalida',
    label: 'Fecha Asignacion Turno De Salida',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'claveCereal',
    label: 'Clave Cereal',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal Variedad',
    width: 60,
    mantenerCase: true
  },

  {
    name: 'exportador',
    label: 'Exportador',
    width: 60,
    mantenerCase: true
  },

  {
    name: 'titular',
    label: 'Titular',
    width: 60,
    mantenerCase: true
  },

  {
    name: 'titularDeCupo',
    label: 'Titular De Cupo',
    width: 60,
    mantenerCase: true
  },

  {
    name: 'corredorComprador',
    label: 'Corredor Comprador',
    width: 60,
    mantenerCase: true
  },

  {
    name: 'vendedor',
    label: 'Vendedor',
    width: 60,
    mantenerCase: true
  },

  {
    name: 'chofer',
    label: 'Chofer',
    width: 60,
    mantenerCase: true
  },

  {
    name: 'fechaDeEgresoCalado',
    label: 'Fecha De Egreso Calado',
    width: 60,
    mantenerCase: true
  },

  {
    name: 'cartaDePorteAutomotor',
    label: 'Carta De Porte Automotor',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'instancia',
    label: 'Instancia',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'estadoCalificacion',
    label: 'Estado Calificacion',
    width: 60,
    mantenerCase: true
  },

  {
    name: 'claveCalificacionCereal',
    label: 'Clave Calificacion Cereal',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'calificacionCereal',
    label: 'Calificacion Cereal',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'humedad',
    label: 'Humedad',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'zarandeo',
    label: 'Zarandeo',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'motivoDeZarandeo',
    label: 'MotivoDeZarandeo',
    width: 60,
    mantenerCase: true
  },

  {
    name: 'peritoCalador',
    label: 'Perito Calador',
    width: 60,
    mantenerCase: true
  },

  {
    name: 'pesoBruto',
    label: 'Peso Bruto',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'fechaDeBruto',
    label: 'Fecha De Bruto',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'balanzaDeBruto',
    label: 'Balanza De Bruto',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoNeto',
    label: 'Peso Neto',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoTara',
    label: 'Peso Tara',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'fechaDeDestare',
    label: 'Fecha De Destare',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'fechaDeRechazoEnPesado',
    label: 'Fecha De Rechazo En Pesado',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'balanzaDeDestare',
    label: 'Balanza De Destare',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'rechazoEnPesado',
    label: 'Rechazo En Pesado',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'fechaDeVolcado',
    label: 'Fecha De Volcado',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'volcadoraCamiones',
    label: 'Volcadora Camiones',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'rechazoEnVolcado',
    label: 'Rechazo En Volcado',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'fumigado',
    label: 'Fumigado',
    width: 60,
    mantenerCase: true
  }
]
